import React from 'react';
import { Box, styled } from '@mui/material';

const Background = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: '-250px',
  left: 0,
  bottom: 0,
  right: 0,
  transform: 'skewY(-12deg)',
  zIndex: 0,

  '& .grayBg': {
    height: '60%',
    width: '100%',
    backgroundColor: '#f7fafc',
    top: '-100px',
    left: 0,
    transformOrigin: '0%',
  },
}));

const Content = styled(Box)(({ theme }) => ({
  position: 'relative',
  maxWidth: 1080,
  margin: '0 auto',
  padding: theme.spacing(2.5, 2),
  border: '1px solid #eceef4',
  minHeight: '100vh',
  zIndex: 1,
}));

const AuthLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box>
      <Background>
        <Box className="grayBg" />
      </Background>
      <Content>{children}</Content>
    </Box>
  );
};

export default AuthLayout;
